<template>
  <div>
    <div>
      <div class="nav" @click="jump">
        <img
          src="../../assets/img/home/logo.png"
          alt=""
          style="width: 40px; height: 40px; margin-right: 15px"
        />
        <span>布尔清单</span>
      </div>
    </div>
    <div class="returnHome" @click="returng">返回</div>
    <!-- <main-navbar :psMsg="0"></main-navbar> -->
    <div class="information">
      <div style="font-weight: bold">个人资料</div>
      <div class="information_content">
        <div class="photo">
          <img :src="imageUrl" alt="" />
        </div>

        <div class="upload_pic_btn">
          <el-upload action :show-file-list="false" :http-request="upLoadPic">
            <div class="upLoad_btn">上传头像</div>
          </el-upload>
        </div>
        <div class="information_content_two">
          <span>昵称</span>
          <input
            type="text"
            placeholder="最多8个字符"
            maxlength="8"
            v-model="nickname"
          />
        </div>
        <div class="information_content_two">
          <span>手机号</span>
          <input type="text" placeholder="请输入手机号" v-model="tel" />
        </div>
        <div class="information_content_two">
          <span>性别</span>
          <div class="gender">
            <p
              style="margin-right: 25px"
              @click="genderBtn(1)"
              :class="gendertn == 1 ? 'genderbgc' : ''"
            >
              <img src="../../assets/img/login/man.png" alt="" />
              男
            </p>
            <p @click="genderBtn(0)" :class="gendertn == 0 ? 'genderbgc' : ''">
              <img src="../../assets/img/login/girl.png" alt="" />
              女
            </p>
          </div>
        </div>
        <div class="information_content_two">
          <span>生日</span>
          <el-date-picker
            v-model="time"
            :clearable="false"
            type="date"
            placeholder="请选择"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </div>
        <div class="information_content_two">
          <span>地区</span>
          <!-- <area-cascader :level="1" type="text"  v-model='form.address' :data="pcaa"></area-cascader> -->
          <area-cascader
            v-model="selected2"
            type="text"
            placeholder="请选择地区"
            :data="pcaa"
            class="selectdq"
            @change="handleItemChange"
          ></area-cascader>
        </div>
        <div class="completeBtn">
          <el-button @click="finish">完成</el-button>
          <el-button @click="jump">取消</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "vue-area-linkage/dist/index.css";
import { pca, pcaa } from "area-data";
export default {
  components: {
  },
  data() {
    return {
      //头像
      imageUrl: require("../../assets/img/home/logo.png"),
      //昵称
      nickname: "",
      //手机号
      tel: "",
      //生日
      time: "1999-6-6",

      pca: pca,
      pcaa: pcaa,
      //地址
      selected2: "",
      //性别
      gendertn: 1,
      city: "",
      province: "",
      //传过来的信息
      user: "",
      userInfo: "",
    };
  },
  methods: {
    //返回首页
    returng(){
      this.$router.push({ name: "home" });
    },
    handleItemChange(option) {
      console.log(this.selected2, "jjjjjjjjj");
      console.log(option, "1111111111");
      this.province = option[0];
      this.city = option[1];
    },
    jump() {
      this.$router.push({ name: "home" });
    },
    //传图片
    upLoadPic(file) {
      console.error(file);
      let header = {
        "Content-Type": "multipart/form-data",
      };
      let data = new FormData(); //创建空对象
      data.append("img", file.file);
      this.$api.uploadPic(data, header).then((res) => {
        console.error(res);
        this.imageUrl = res.data.results;
        console.log(this.imageUrl);
      });
    },
    //性别选择
    genderBtn(index) {
      this.gendertn = index;
    },
    //点击完成
    finish() {
      if (this.nickname != "" && this.tel != "" && this.selected2 != "") {
        if (this.imageUrl == "../../assets/img/home/logo.png") {
          this.imageUrl = "";
        }
        var re = /^1\d{10}$/;
        let str = this.tel;
        if (re.test(str)) {
          let header = {
            Authorization: "Bearer " + localStorage.getItem("token"),
          };
          let data = {
            gender: this.gendertn,
            real_name: "",
            nick_name: this.nickname,
            avatar_url: this.imageUrl,
            city: this.city,
            source_app: "dairy",
            province: this.province,
            birthday: this.time,
            invite_code: "",
            motto: "",
          };
          this.$api
            .updateUserBasicInfo(data, header)
            .then((res) => {
              this.$util.mesBoxPop("提交成功", "success");
              console.log(res);
              this.$router.push({ name: "home" });
            })
            .catch((err) => {
              console.log(err);
              this.$util.mesBoxPop("提交失败", "warning");
            });
        } else {
          this.$util.mesBoxPop("手机号格式错误", "warning");
        }
      } else {
        this.$util.mesBoxPop("信息未完善", "warning");
      }
    },
  },
  mounted() {},
  created() {
    let header = {
      Authorization: "Bearer " + localStorage.getItem("token"),
    };
    let data = {};
    this.$api
      .queryUserNickImg(data, header)
      .then((res) => {
        console.log(res, "gerenxinxi ");
        this.userInfo = res.data.results;
        //头像
        this.imageUrl = this.userInfo.avatar_url;
         if (this.imageUrl == null ) {
          this.imageUrl = require("../../assets/img/home/logo.png");
        }
        //昵称
        this.nickname = this.userInfo.nick_name;
        //手机号
        this.tel = this.userInfo.custom_username;
        //生日
        this.time = this.userInfo.birthday;
        //地址
        this.province = this.userInfo.province;
        this.city = this.userInfo.city;
        this.selected2 = [this.province, this.city];
        //性别
        this.gendertn = this.userInfo.gender;
      })
      .catch((err) => {
        console.log(err);
      });
  },
};
</script>

<style lang="scss" scoped>
.nav {
  position: fixed;
  top: 0;
  z-index: 999;
  width: 100%;
  height: 80px;
  padding: 0 8%;
  border-bottom: 2px solid #f3f3f3;
  display: flex;
  align-items: center;
  font-size: 24px;
  font-family: SourceHanSansSC-Bold;
  font-weight: bold;
  background-color: #fff;
}
.returnHome {
    position: fixed;
    top: 100px;
    right: 5%;
    width: 50px;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 12px;
    background-color: #e1e1e1;
    border-radius: 50%;
    z-index: 3;
  }
.information {
  height: 1000px;
  margin: 90px 200px 20px 200px;
  padding: 54px 66px;
  background-color: #fff;
  font-size: 19px;
  color: #333;
  font-family: SourceHanSansSC-Regular;
  .information_content {
    width: 700px;
    margin: 0 auto;
    padding-top: 40px;
    .photo {
      width: 66px;
      height: 66px;
      margin: 0 auto 27px;

      img {
        width: 100%;
        height: 100%;
        border-radius: 50%;
      }
    }
    .upload_pic_btn {
      text-align: center;
      .upLoad_btn {
        width: 75px;
        line-height: 36px;
        font-size: 13px;
        background-color: #f6f6f6;
        border-radius: 2px;
      }
    }
    .information_content_two {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 20px 30px;
      border-bottom: 1px solid #dcdcdc;
      span {
        display: inline-block;
        width: 15%;
        font-size: 19px;
        color: #333;
        font-weight: bold;
      }
      input {
        height: 60px;
        width: 70%;
        text-align: right;
        font-size: 19px;
        border: none;
      }
      .el-icon-date:before {
        content: none;
      }
      .el-input__inner {
        font-size: 20px;
        width: 250px;
      }
      .selectdq {
        span {
          width: 100%;
        }
      }
      .area-select.large {
        width: 100%;
        height: 60px;
        line-height: 60px;
        border: none;
        i {
          margin-top: 5px;
        }
      }
      .area-selected-trigger {
        font-size: 19px;
        font-weight: normal;
        color: #333333;
      }
      .gender {
        height: 60px;
        line-height: 60px;
        font-size: 14px;
        p {
          display: inline-block;
          background-color: #f3f3f3;
          height: 27px;
          line-height: 27px;
          width: 70px;
          border-radius: 16px;
          text-align: center;
        }
        img {
          width: 11px;
          height: 11px;
        }
      }
      .genderbgc {
        background-color: #1cbb9b !important;
        color: #fff;
      }
    }
    .completeBtn {
      width: 100%;
      text-align: center;
      margin-top: 67px;
      .el-button {
        width: 80px;
        height: 30px;
        background-color: #00ad90;
        border-radius: 3px;
        color: #fff;
        font-size: 14px;
        padding: 0;
        margin: 0 10px;
      }
    }
  }
}
</style>